








import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames } from '@/templates/DataNames';
import { currentInstance } from '@/heplers';

@Component({})
export default class SearchInput extends Vue {
  @Prop({ type: Boolean, default: false }) isPage: boolean;
  @Prop({ type: String, default: 'Search in the documentation' }) searchPlaceholder: string;
  @Prop({ type: String, default: '' }) initialInputValue: string;
  @Prop({ type: Boolean, default: false }) isMobile: boolean;
  public searchInput = '';

  get computeSearchClass() {
    return {
      'is-page': this.isPage,
      'is-mobile': this.isMobile,
      'is-desktop': !this.isMobile,
    };
  }

  mounted() {
    this.searchInput = <string>this.$router.currentRoute.query.q;

    GlobalBus.on(GlobalBusNames.RENDERSEARCH, () => {
      if (this.isPage) this.searchInput = <string>this.$router.currentRoute.query.q;
    });
  }

  sendGtmSearch(_query: string) {
    this.$sendGtmEvent({
      event: 'vox_docs_search',
      category: 'search',
      action: 'enter',
      label: this.searchInput + this.$router.currentRoute.path,
    });
  }

  submitSearch() {
    this.sendGtmSearch(this.searchInput);
    if (!this.searchInput?.length) return;

    if (document.body.clientWidth < 1024) GlobalBus.emit(GlobalBusNames.CLOSEMOBILEMENU);

    let url = currentInstance === 'vox' ? '/docs/search?q=' : '/kit/docs/search?q=';

    if (this.$router.currentRoute.fullPath === url + this.searchInput) return;

    this.$router
      .push(url + this.searchInput)
      .then(() => (this.searchInput = ''))
      .catch((error) => error);
  }
}
